import React from 'react';
import PropTypes from 'prop-types';
import { Badge as AntdBadge } from 'antd';

const Badge = ({ count, maxCount, ...props }) => (
    <AntdBadge overflowCount={maxCount} count={count} offset={[0, -7]} size="small" {...props} />
);

Badge.propTypes = {
    maxCount: PropTypes.number,
    count: PropTypes.number.isRequired,
};

export default Badge;
